import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  List,
  Box,
  Flex,
  Link,
  CriteriaTag,
  Checkbox,
  Text,
  Dropdown
} from "samba-ui";
import styled from "styled-components";
import PermissionModal from "./PermissionModal";
import DeletePermissionModal from "./DeletePermissionModal";
import { getSelectedDateRangeByValue } from "./SetDateRange";
const StyledLink = styled(Link)`
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
`;

const DisabledBox = styled(Box)`
  opacity: 0.5px;
  pointer-events: none;
`;

const StyledText = styled(Box)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 150px;
  font-weight: 500;
`;

const SinglePermission = ({
  user,
  id,
  name,
  filters: periscopeFilters = {},
  visible = [],
  onFilterUpdate,
  onFilterDelete,
  isCustom,
  isDefault
}) => {
  const isSuperOperator = user.role === "superoperator";
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);

  const onPermissionUpdate = body => {
    onFilterUpdate(id, body);
    setEditMode(false);
  };

  const onPermissionDelete = id => {
    setDeleteMode(false);
    onFilterDelete(id);
  };

  return (
    <Box>
      <List.Item borderColor="#d6d6d6 !important">
        <Flex alignItems="center" justifyContent="center">
          <Box width={1 / 6}>
            <StyledText fontSize={1} color="secondary">
              {name}
            </StyledText>
          </Box>

          <Box width={1 / 6}>
            <Text>{Object.keys(periscopeFilters)[0]}</Text>
          </Box>
          <Box width={3 / 12}>
            <Flex ml={4} alignItems="center" flexWrap="wrap">
              {!isCustom ? (
                Object.values(periscopeFilters)[0].map(v => (
                  <Box key={v} mr={2}>
                    <CriteriaTag>{v}</CriteriaTag>
                  </Box>
                ))
              ) : (
                <DisabledBox width={150}>
                  <Dropdown
                    selected={getSelectedDateRangeByValue(
                      Object.values(periscopeFilters)[0]
                    )}
                  />
                </DisabledBox>
              )}
            </Flex>
          </Box>
          <Box width={1 / 12}>
            <Checkbox
              id="isCustom"
              checked={isCustom}
              disabled
              onChange={() => {}}
            />
          </Box>
          <Box width={1 / 12}>
            <Checkbox
              id="visible"
              checked={!!visible.length}
              disabled
              onChange={() => {}}
            />
          </Box>
          <Box width={1 / 12}>
            <Checkbox
              id="isDefault"
              checked={isDefault}
              disabled
              onChange={() => {}}
            />
          </Box>
          <Flex
            width={1 / 6}
            alignItems="center"
            justifyContent="space-around"
            fontSize={1}
            fontWeight={500}
          >
            <StyledLink
              disabled={isSuperOperator}
              onClick={() => setEditMode(true)}
            >
              Edit
            </StyledLink>
            <StyledLink
              onClick={() => setDeleteMode(true)}
              color="alert"
              disabled={isSuperOperator || isDefault}
            >
              Delete
            </StyledLink>
          </Flex>
        </Flex>
      </List.Item>
      {
        <PermissionModal
          isOpen={editMode}
          onClose={() => setEditMode(false)}
          onSubmit={onPermissionUpdate}
          permissionName={name}
          permissionFilterName={Object.keys(periscopeFilters)[0]}
          isVisible={!!visible.length}
          isDefault={isDefault}
          isCustom={isCustom}
          permissionFilterValues={Object.values(periscopeFilters)[0]}
        />
      }
      <DeletePermissionModal
        isOpen={deleteMode}
        onClose={() => setDeleteMode(false)}
        id={id}
        name={name}
        isDefault={isDefault}
        onDelete={onPermissionDelete}
      />
    </Box>
  );
};

SinglePermission.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  filters: PropTypes.object,
  visible: PropTypes.array,
  onFilterUpdate: PropTypes.func,
  onFilterDelete: PropTypes.func,
  user: PropTypes.object
};

export default SinglePermission;
